<template>
  <el-form ref="formSocialMedia" class="block-social-media" v-if="checkDiffusionWithNetworkName(networkName)">
    <div class="overviewRs">
      <div class="overviewRs-left">
        <el-checkbox v-model="isActive" class="overviewRs-checkbox" @change="updateActive" :disabled="allRSPublished"></el-checkbox>
        <p><img :src="iconSrc" :alt="`Icon ${networkName}`" class="overviewRs-icon"/></p>
        <p class="overviewRs-title">{{ networkName }}</p>
      </div>

      <div class="overviewRs-right">
        <p v-if="socialStatusPosts.status === 'scheduled'"><strong>{{ $t('socialMedia.statusScheduled') }} :</strong> {{ formatDate(socialStatusPosts.date) }}</p>
        <p v-if="socialStatusPosts.status === 'published'"><strong>{{ $t('socialMedia.statusPublished') }} :</strong> {{ formatDate(socialStatusPosts.date) }}</p>
      </div>
    </div>

    <transition name="fade">
      <div v-show="isActive">
        <div>
          <h2 class="title">{{ $t('socialMedia.titleContent') }}</h2>
          <p>{{ $t('socialMedia.titleContentDescription') }}
            <span v-if="hasOptionIaAndPersoPrompt">
              <el-tooltip placement="top-start" :content="$t('socialMedia.tooltipPromptInstruction')">
              <em class="el-icon-question"></em>
              </el-tooltip>
            </span>
          </p>
          <PostContentEditor
            :networkName="networkName"
            @reset-caption="resetCaption"
            :statusPost="socialStatusPosts.status"
          />
          <!-- Affichage conditionnel basé sur getMediaType du store postManager -->
          <PostVideoFileUrlCustom
            v-if="getMediaType === 'url'"
            @updateValue="setError"
            @change-tab="updateCurrentTab"
            @video-url-changed="onVideoUrlChanged"
            :parent-video-url="parentVideoUrl"
            :data="{
              'post': getCurrentPost,
              'networkName': networkName,
              'statusPost': socialStatusPosts.status,
              'isCurrentlyPublished': isCurrentlyPublished
            }"
          />

          <upload-video
            v-if="getMediaType === 'upload'"
            :post-id="getCurrentPost.id"
            networkName="initial"
            :none-display-button-remove="true"
          />

          <PostPhotosCustom
            v-if="getMediaType === 'image'"
            :photos="photos"
            :network-name="networkName"
            :status-post="socialStatusPosts.status"
            :is-currently-published="isCurrentlyPublished"
          />
        </div>
      </div>
    </transition>

  </el-form>
  <el-row v-else>
    <el-col :span="24">
      <div class="container-message-commercial">
        <div class="box-commercial">
          <p>{{ $t('posts.networks.commercialText1') }} <strong>{{networkName}}</strong> {{ $t('posts.networks.commercialText1Bis')}}</p>
          <p>{{$t('posts.networks.commercialText3')}} <strong>{{networkName}}</strong>  {{ $t('posts.networks.commercialText3Bis')}}</p>
          <div class="text-center">
            <el-button type="primary" v-if="!isSubUser" @click="contactTeam"> Soyez recontacté par notre équipe.</el-button>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import { mapGetters } from 'vuex'
import PostContentEditor from './PostContentEditor.vue'
import PostVideoFileUrlCustom from '@/pages/posts/components/PostVideoFileUrlCustom.vue'
import PostPhotosCustom from './PostPhotosCustom.vue'
import moment from 'moment'
import UploadVideo from '@/components/Upload/UploadVideo.vue'

export default {
  name: 'SocialMediaCard',
  components: {
    UploadVideo,
    PostContentEditor,
    PostVideoFileUrlCustom,
    PostPhotosCustom
  },
  props: {
    networkName: {
      type: String,
      required: true
    },
    iconSrc: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    parentVideoUrl: {
      type: String,
      default: ''
    },
    photos: {
      type: Array,
      default: () => []
    },
    selectedPhotos: {
      type: Array,
      default: () => []
    },
    allRSPublished: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isActive: this.active,
      errors: {},
      isCurrentlyPublished: false
    }
  },
  computed: {
    ...mapGetters(['getUser', 'hasOptionIaAndPersoPrompt', 'possedeClapVideo', 'hasPackSocialManager', 'isSubUser', 'getDiffusionsRs']),
    ...mapGetters('postManager', ['getCurrentPost', 'isBienVendu', 'universe', 'getSocialStatusPosts', 'getLoadingDiffusions', 'getStatusMediaPost', 'getMediaType', 'hasAnyMedia']),
    socialStatusPosts () {
      return this.getSocialStatusPosts[this.networkName]
    },
    sitimmoUser () {
      return this.$store.state.app.sitimmoUser
    },
    checkDiffusionWithNetworkName (nomReseau) {
      return (nomReseau) => {
        return this.getDiffusionsRs.some(reseau =>
          reseau[1].toLowerCase().includes(nomReseau.toLowerCase())
        )
      }
    }
  },
  watch: {
    socialStatusPosts: {
      handler (newStatus, oldStatus) {
        // Si le statut change vers publié ou planifié, activer
        if (newStatus && (newStatus.status === 'published' || newStatus.status === 'scheduled')) {
          this.isActive = true
        }
        // Si le statut était planifié/publié et devient null/undefined, désactiver
        else if (oldStatus && (oldStatus.status === 'published' || oldStatus.status === 'scheduled') &&
                 (!newStatus || (!newStatus.status || newStatus.status === 'no planned'))) {
          this.isActive = false
          this.$emit('update:active', false)
        }
      },
      immediate: true
    },
    active (newValue) {
      this.isActive = newValue
    }
  },
  methods: {
    updateActive () {
      this.$emit('update:active', this.isActive)
    },
    formatDate (date) {
      if (date && /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/.test(date)) {
        return date
      }
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    resetCaption () {
      const titleDialog = this.hasOptionIaAndPersoPrompt ? this.$t('prompt.resetPrompt') : this.$t('posts.adResetDialogTitle')
      const textDialog = this.hasOptionIaAndPersoPrompt ? this.$t('prompt.resetPromptDialog') : this.$t('posts.adResetDialog')
      this.$confirm(titleDialog, textDialog, {
        confirmButtonText: this.$t('prompt.validate'),
        cancelButtonText: this.$t('prompt.cancel'),
        type: 'info'
      }).then((response) => {
        if (response === 'confirm') {
          this.$store.dispatch('caption/resetCaption', {
            network: this.networkName,
            universe: this.universe,
            post: this.getCurrentPost,
            bienVendu: this.isBienVendu
          })
        }
      })
    },
    setError (errorKey, errorMessage) {
      if (errorMessage === 'delete') {
        delete this.errors[errorKey]
      } else {
        this.errors[errorKey] = errorMessage
      }
    },
    updateCurrentTab (tabName) {
      this.$emit('change-tab', tabName)
    },
    onVideoUrlChanged (data) {
      this.$emit('video-url-changed', data)
    },
    contactTeam () {
      window.open('https://www.ubiflow.net/annonces-immobilieres-google-facebook-instagram')
    }
  }
}
</script>
<style lang="scss" scoped>
.block-social-media {
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  background-color: transparent;
  border-bottom: none;
  padding: 0;

  .title {
    color: #1a4a56;
    font-weight: 600;
    font-size: 15px;
    margin-top: 15px;
  }

  .overviewRs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0 10px 0;
    border-bottom: 1px solid #0ab1bf;
    min-height: 50px;

    &-left {
      display: flex;
      align-items: center;
      gap: 10px;

      .el-checkbox {
        margin-right: 0;
        margin-bottom: 0;
      }

      p {
        margin: 0;
        display: flex;
        align-items: center;
        line-height: 1;
      }
    }

    &-right {
      text-align: right;
      display: flex;
      align-items: center;

      p {
        margin: 0;
        line-height: 1;
      }
    }

    &-icon {
      width: 20px;
      height: 20px;
      object-fit: contain;
      display: block;
    }

    &-title {
      font-size: 20px;
      color: #1a4a56;
      margin: 0;
      line-height: 1;
    }
  }

  .description-text {
    color: #1a4a56;
    p {
      margin: 0;
    }
  }

  .style-bold-gray {
    font-weight: bold;
    color: #7f7f7f;
  }

}

.fade-enter-active, .fade-leave-active {
  transition: all 0.4s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.mb-4 {
  margin-bottom: 1rem;
}

.mt-4 {
  margin-top: 1rem;
}

.radio-vertical {
  .radio-item {
    display: block;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

</style>
